import createVueApp from '@phoenix/createVueApp';
import QrModal from '@maison/components/organisms/modals/QrModal.vue';

document.querySelectorAll('.phoenix-modal-qr').forEach((el) => {
  const app = createVueApp();
  app.component('QrModal', QrModal);
  app.mount(el);
});
